module.exports = __webpack_public_path__ + "img/dairenl.c86240dc.png";